import { Link } from "@/components/Link";
import {
  FaGithub,
  // FaBitbucket,
  // FaGitlab,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import ToolTip from "@/components/ui/ToolTip";

const socials = [
  {
    name: "LinkedIn",
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/in/massifwebstudio/",
  },

  { name: "Github", icon: <FaGithub />, url: "https://github.com/ynamite" },
  // { name: "Gitlab", icon: <FaGitlab />, url: "https://gitlab.com/ynamite/" },
  // {
  //   name: "Bitbucket",
  //   icon: <FaBitbucket />,
  //   url: "https://bitbucket.org/ynamite/",
  // },
  {
    name: "Instagram",
    icon: <FaInstagram />,
    url: "https://www.instagram.com/ynamite/",
  },
];

const Social = ({
  containerStyles,
  iconStyles,
}: {
  containerStyles?: string;
  iconStyles?: string;
}) => {
  return (
    <div className={containerStyles}>
      {socials.map((social, index) => (
        <ToolTip
          content={social.name}
          key={index}>
          <div>
            <Link
              title={social.name}
              href={social.url}
              className={iconStyles}
              target="_blank"
              rel="noreferrer">
              {social.icon}
            </Link>
          </div>
        </ToolTip>
      ))}
    </div>
  );
};

export default Social;
